module.exports = __webpack_public_path__ + "static/media/legal.66623440.svg";